// extracted by mini-css-extract-plugin
export default {"ticketsStatusContent":"TicketsStatus_ticketsStatusContent__8eWMc","info":"TicketsStatus_info__ngAZQ","dot":"TicketsStatus_dot__-Zd+n"};